// extracted by mini-css-extract-plugin
module.exports = {"slot":"styles_slot__xbZfb","selected":"styles_selected__FNFeM"};